import styled from 'styled-components';

export const BarsGroup = styled.g.attrs(({ top = 0, left = 0 }) => ({
  transform: `translate(${left}, ${top})`,
}))`
  transition: opacity 0.3s ease-in;
  opacity: ${({ isHoverActive, isGroupHovered }) => (isHoverActive && !isGroupHovered ? 0.3 : 1)};
`;

export const Container = styled.div``
